export const getExtension = (file) => {
    return file.split(".").pop().toLowerCase();
};
